import * as React from "react";
import { Component } from "react";

interface IProps {
    OnAccept: () => void;
}

export class CookieInfoComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);

        this.OnAccept = this.OnAccept.bind(this);
    }

    public render() {
        return (
            <div className="cookie-info-component">
                Strona korzysta z plików cookies w celu realizacji usług i
                zgodnie z <b>Polityką Plików Cookies</b>. Możesz określić warunki
                przechowywania lub dostępu do plików cookies w Twojej
                przeglądarce.
                <button className="std-primary-btn" onClick={this.OnAccept}>
                    Akceptuję
                </button>
            </div>
        );
    }

    private OnAccept(evt) {
        this.props.OnAccept();
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/CookieInfo.tsx